import type { FaireProductEntity } from "../../entity_types/product";

export const p_e5cyfnqn4w: FaireProductEntity = {
  token: "p_e5cyfnqn4w",
  type: "product",
  name: "Paw Towel | Green",
  brandToken: "b_bf7zwxbsts",
  brandName: "Dandylion",
  imageUrl: "https://cdn.faire.com/fastly/fc3c850874e4a0a160865a221398ce06847290b099220a2cfc595086a58d4ab2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6d68ee029a4b5f2426ac6fca1f7281b4b745b16155391c72e09dbd7e508f725a.jpeg"
  ],
  priceDollars: 5,
  description: "Dandylion’s 100% cotton waffle weave towel pairs perfectly with your Clean Paws No-Rinse Foaming Cleanser to provide a gentle exfoliation and clean for the paws or Fresh Coat Daily Cleansing Spray to provide a quick daily wipe down.\n\n• 100% Cotton: Skin-friendly, absorbent and breathable fabric that is gentle & non-irritating to the skin\n• Waffle Weave: Offers exceptional moisture-wicking and absorption qualities, surpassing traditional flat weaves, making it the ideal choice for drying wet paws.\n\nTo clean:\n\n• Wash in cold water using a delicate cycle or hand wash in cold water.\n• For best results, hang dry to prevent any potential shrinkage.\n• Please note due to the waffle weave pattern & natural fibres, it is normal to experience slight shrinkage after the initial wash. To minimize shrinkage, wash towel in cold water and avoid high heat during the drying process.\n\n12 inches x 12 inches. Made in India.",
  tags: [],
  msrpDollars: 10,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T16:24:40.388Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
